
/* injects from baggage-loader */

import React, { useEffect } from "react";
import { connect } from "react-redux";
import { browserHistory, withRouter } from "react-router";
import { createSelector } from "reselect";
import { getRegionCompetition } from "../../../helpers/terminalRequests/regionsList";
import { GetArrayRegion } from "../../../helpers/util/swarmTreeDestructuring";
import { getSwarmDataKeyForRequest, SwarmDataMixin } from "../../../mixins/swarmDataMixin";
import { toggleActiveClassRegion } from "../../../actions/ui";
import CompetitionList from "./competitionList";

function RegionWrapper(props) {
	const data = props.data && GetArrayRegion(props.data);
	//const compData = Object.values(props.competition).sort((a, b) => a.order - b.order);

	useEffect(() => {
		const { params } = props;

		if (data && params) {
			const region = data[0];
			const competition = region && Object.values(region.competition)[0];

			if (competition) {
				+params.competitionId === competition.id &&
					props.dispatch(toggleActiveClassRegion(parseInt(competition.id)));
				!params.competitionId &&
					browserHistory.push(
						`/${props.gameType}/${props.sportAlias}/${region.id}/${competition.id}`
					);
			}
		}
	}, [props.gameType, props.sportAlias, data]);

	return (
		<div className="competition-list-wrap">
			<div className="competition-list-wrap-inner">
				{data &&
					data.map(item => (
						<CompetitionList
							key={item.id}
							cursor={props.cursor}
							regionId={item.id}
							gameType={props.gameType}
							sportAlias={props.sportAlias}
							competition={item.competition}
						/>
					))}
			</div>
		</div>
	);
}

const mapStateToProps = (state, ownParams) => {
	let key = getSwarmDataKeyForRequest(getRegionCompetition(ownParams.sportAlias, ownParams.gameType));
	return createSelector(
		[
			state => state.swarmData.loaded[key],
			state => state.swarmData.data[key] && state.swarmData.data[key],
			state => state.uiState.toggleRegionid.cursor,
		],
		(loaded, data, cursor) => {
			return {
				data: data,
				loaded,
				cursor,
			};
		}
	);
};

export default connect(mapStateToProps)(
	SwarmDataMixin({
		Component: withRouter(RegionWrapper),
		ComponentWillMount: function () {
			let { sportAlias, gameType } = this.props;
			this.swarmSubscriptionRequest = getRegionCompetition(sportAlias, gameType);
			this.swarmDataKey = getSwarmDataKeyForRequest(getRegionCompetition(sportAlias, gameType));
		},
	})
);
